import {FaDownload, FaEnvelope, FaSignOutAlt} from "react-icons/fa";
import {FaHouse} from "react-icons/fa6";

const Submenu = [
    {
        "name": "Mensagens",
        "permissions": "",
        "icon": FaEnvelope,
        "url": "user-messages",
        "id": "user-messages"
    },
    {
        "name": "Downloads",
        "permissions": "",
        "icon": FaDownload,
        "hide_dispatch": true,
        "url": "download",
        "id": "download"
    },
    {
        "name": "Home",
        "permissions": "",
        "icon": FaHouse,
        "hide_web": true,
        "url": "home",
        "id": "home"
    },
    {
        "name": "Meu Agente",
        "permissions": "",
        "icon": "icon-sw-user-police",
        "url": "my-user",
        "id": "myUser"
    },
    {
        "name": "Sair",
        "permissions": "",
        "url": "logout",
        "id": "logout"
    }
];

export default Submenu;